import image from '../images/a347ce99-9901-4361-953e-f3306909469c.JPG';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../AuthContext";

function ListeNaissance() {
    const [birthList, setBirthList] = useState([]);
    const [selectedGifts, setSelectedGifts] = useState({});
    const totalGiftAmount = Object.values(selectedGifts).reduce((acc, val) => acc + Number(val || 0), 0);
    const navigate = useNavigate();
    const { getToken, loading } = useContext(AuthContext);

    // Charger les contributions précédentes depuis le localStorage
    useEffect(() => {
        const savedGifts = localStorage.getItem('selectedGifts');
        if (savedGifts) {
            setSelectedGifts(JSON.parse(savedGifts));
        }
    }, []);

    // Sauvegarder dans localStorage à chaque mise à jour
    useEffect(() => {
        localStorage.setItem('selectedGifts', JSON.stringify(selectedGifts));
        localStorage.setItem('giftListKind', 'birth');
    }, [selectedGifts]);

    useEffect(() => {
        const loadBirthList = async () => {
            if (loading) return;
            try {
                const token = await getToken();
                const res = await fetch(`/api/birth-list-items`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                const data = await res.json();
                setBirthList(data.categories || []);
            } catch (error) {
                console.error("Erreur lors du chargement de la liste sécurisée :", error);
                setBirthList([]);
            }
        };
        loadBirthList();
    }, [getToken, loading]);

    const handleGiftChange = (id, value) => {
        setSelectedGifts((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    return (
        <div>
            <div
            className="hero"
            style={{ backgroundImage: `url(${image})`, height: "250px" }}
            >
                <div className="hero-inner">
                    <div className="inner">
                    <div className="hero-line-one">
                        Liste de Naissance & Contribution
                    </div>
                    </div>
                </div>
            </div>
            <div className="wrap full-wrap">
                <div className="main-wrap">
                    <section className="main" style={{ paddingLeft: '10px' }}>
                        <p style={{ marginTop: '20px' }}>
                            Merci infiniment pour votre attention ! Choisissez un ou plusieurs cadeaux
                            ci-dessous et indiquez le montant que vous souhaitez offrir : chaque
                            contribution, même modeste, compte énormément pour nous.
                        </p>
                        {birthList.map((category) => (
                            <div key={category.name} style={{ marginTop: '40px' }}>
                                <h3>{category.name}</h3>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                                    {category.items.map((item) => (
                                        <div key={item.id} style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '16px', width: '300px' }}>
                                            {item.image_url ? (
                                                <img src={item.image_url} alt={item.title} style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '4px' }} />
                                            ) : (
                                                <div style={{
                                                    width: '100%',
                                                    height: '180px',
                                                    borderRadius: '4px',
                                                    background: '#f2f2f2',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '2.5em'
                                                }} aria-hidden="true">🎁</div>
                                            )}
                                            <h4>{item.title}</h4>
                                            <p>{item.description}</p>
                                            <p>
                                                {item.montant_collecte.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })} /
                                                {item.montant_cible.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
                                            </p>
                                            <div style={{ height: '10px', background: '#eee', borderRadius: '4px', overflow: 'hidden' }}>
                                                <div style={{
                                                    width: `${Math.min(100, (item.montant_collecte / item.montant_cible) * 100)}%`,
                                                    background: '#4CAF50',
                                                    height: '100%'
                                                }}></div>
                                            </div>
                                            <input
                                                type="number"
                                                min="0"
                                                placeholder="€ 20, 50, 100..."
                                                value={selectedGifts[item.id] || ''}
                                                onChange={(e) => handleGiftChange(item.id, e.target.value)}
                                                style={{ width: '100%', marginTop: '10px' }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                        {totalGiftAmount > 0 && (
                            <footer style={{
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                width: '100%',
                                background: '#fff',
                                borderTop: '1px solid #ccc',
                                padding: '10px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                zIndex: 1000,
                                boxShadow: '0 -2px 6px rgba(0,0,0,0.1)'
                            }}>
                                <h4 style={{ margin: 0 }}>Total de votre contribution : {totalGiftAmount.toFixed(2)} €</h4>
                                <div style={{display: 'flex'}}>
                                    <button style={{ marginRight: '10px', padding: '10px 20px' }} onClick={() => setSelectedGifts({})}>
                                        Réinitialiser les montants
                                    </button>
                                    <button style={{ padding: '10px 20px' }} onClick={() => navigate('/paiement')}>
                                        Procéder au paiement
                                    </button>
                                </div>
                            </footer>
                        )}
                    </section>
                </div>
            </div>
        </div>
    )
}

export default ListeNaissance;
